import { Component, ChangeDetectionStrategy, LOCALE_ID, inject } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { LanguageDescriptionModel } from './language-description.model';
import { LanguageHelper } from './language.helper';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'tm-language-toggle',
    templateUrl: './language-toggle.component.html',
    styleUrls: ['./language-toggle.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatMenu,
        MatMenuItem,
        MatIcon,
        MatMenuTrigger,
    ],
})
export class LanguageToggleComponent {
  private baseHref = inject(APP_BASE_HREF);


  public availableLanguages = LanguageHelper.availableLanguages;
  public selectedLanguage: LanguageDescriptionModel | undefined;

  public canChangeLanguage = false;

  constructor() {
    const locale = inject(LOCALE_ID);

    this.selectedLanguage = this.availableLanguages.find(l => l.code === locale);
    if (this.selectedLanguage) {
      this.canChangeLanguage = this.baseHref.indexOf(`/${this.selectedLanguage.code}`) !== -1;
    }
  }

  public selectLanguage(language: string) {
    const updatedBaseHref = this.baseHref.replace(`/${this.selectedLanguage?.code ||''}`, `/${language}`);
    window.location.href = window.location.href.replace(this.baseHref, updatedBaseHref);
  }

}
